module.exports = __webpack_public_path__ + "static/12-3790f1b184ab598f16bbcaf9cbb5070e.jpg";